export const initialWxOptions = {
    tearoff: true,
    background: true,
    bright: 80,
    font: 2,
    border: true,
    lines: 5,
};
//# sourceMappingURL=initialWxOptions.js.map